import { render, staticRenderFns } from "./jobTitleCurrent.vue?vue&type=template&id=15630397&scoped=true&"
import script from "./jobTitleCurrent.vue?vue&type=script&lang=js&"
export * from "./jobTitleCurrent.vue?vue&type=script&lang=js&"
import style0 from "./jobTitleCurrent.vue?vue&type=style&index=0&id=15630397&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15630397",
  null
  
)

export default component.exports